import useAppTranslation from "@hooks/language/useAppTranslation";
import Icon from "../../shared/icon/Icon";
import InfoCardGrid from "../../shared/info-card/InfoCardGrid";

export const SmurfsRankedFeatures = () => {
  const { t: commonT } = useAppTranslation("pages.handlevel");

  return (
    <InfoCardGrid
      cards={[
        {
          icon: <Icon.FastDelivery size={50} />,
          title: commonT("features.instantDelivery.title"),
          text: commonT("features.instantDelivery.text"),
          withBackground: false,
        },
        {
          icon: <Icon.OpenLock size={50} />,
          title: commonT("features.unverifiedEmail.title"),
          text: commonT("features.unverifiedEmail.text"),
          withBackground: false,
        },
        {
          icon: <Icon.Chat size={50} />,
          title: commonT("features.premiumSupport.title"),
          text: commonT("features.premiumSupport.text"),
          withBackground: false,
        },
      ]}
    />
  );
};
